import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import { getUserData } from '../actions/users'
import './dashboard.css'

export class ViewUser extends React.Component {
	componentWillMount() {
		this.props.dispatch(getUserData(this.props.match.params.userId))
	}

	render() {
		if(!this.props.loggedIn) {
			return <Redirect to='/' />
		}

		const edits = this.props.otherUser.edits
		const texts = this.props.otherUser.texts

		let editList
        edits.length ? editList = edits.map((edit, i) => {
                return <div className='user-item' key={ 'edit-' + i }>
                        <Link to={ {
                            pathname: `/edited/${edit.title}`,
                            state: { editId: edit._id }
                        } }>{ edit.title }</Link>
                    </div>
                })
            : editList = <div className='user-item'></div>

        let textList
        texts.length ? textList = texts.map((text, i) => {
                return <div className='user-item' key={ 'text-' + i }>
                        <Link to={ {
                            pathname: `/text/${text.title}`,
                            state: { textId: text._id }
                        } }>{ text.title }</Link>
                    </div>
                })
            : textList = <div className='user-item'></div>

		return (
			<div>
				<h2 className='dashboard-username'>{ this.props.otherUser.username }</h2>
				<div className='user-data col-6'>
					<div className="user-texts col-6">
						<h3>Papers:</h3>
						{textList}
					</div>
					<div className='user-edits col-6'>
						<h3>Edits:</h3>
						{editList}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	loggedIn: state.auth.uid !== null,
	otherUser: state.user.otherUser
})

export default connect(mapStateToProps)(ViewUser)


// WEBPACK FOOTER //
// ./src/components/view-user.js